import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

// Nouvelles pages Call a Lawyer
import FormulaireRdv from '@/views/formulaire-rdv.vue'
import FormulaireRdvCible from '@/views/formulaire-rdv-cible.vue'
import ConfirmationRdv from '@/views/confirmation-rdv.vue'
import SollicitationAvocat from '@/views/sollicitation-avocat.vue'

// Pages legal
import cguvClient from '@/views/legal/cguv-clients.vue'



const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/rdv'
  },
  {
    path: '/rdv/',
    redirect: '/rdv/call-a-lawyer'
  },

  // Routes de prise de RDV avec avocat (avec domaine/sous-domaine/code postal optionnels)
  // {
  //   path: '/avocat/:slug',
  //   name: 'PriseRdvAvocat',
  //   component: FormulaireRdvCible,
  //   props: route => ({
  //     slugAvocat: route.params.slug,
  //     domaine: route.query.domaine,
  //     sousDomaine: route.query.sousDomaine,
  //     cp: route.query.cp
  //   })
  // },
  // Routes de prise de RDV avec cabinet (avec domaine/sous-domaine/code postal optionnels)
  // {
  //   path: '/cabinet/:slug',
  //   name: 'PriseRdvCabinet',
  //   component: FormulaireRdvCible,
  //   props: route => ({
  //     slugCabinet: route.params.slug,
  //     domaine: route.query.domaine,
  //     sousDomaine: route.query.sousDomaine,
  //     cp: route.query.cp
  //   })
  // },
  {
    path: '/sollicitation/:prescriber/:slugAvocat',
    name: 'SollicitationAvocat',
    component: SollicitationAvocat,
    props: route => ({
      prescriber: route.params.prescriber,
      slugAvocat: route.params.slugAvocat
    })
  },
  // {
  //   path: '/rdv/:prescriber',
  //   name: 'FormulaireRdv',
  //   component: FormulaireRdv,
  //   props: route => ({
  //     prescriber: route.params.prescriber
  //   })
  // },
  // {
  //   path: '/rdv/:prescriber/confirmation',
  //   name: 'ConfirmationRdv',
  //   component: ConfirmationRdv,
  //   props: route => ({
  //     prescriber: route.params.prescriber
  //   })
  // },

  // Routes legal
  // {
  //   path: '/legal/cguv-client',
  //   name: 'CGUV Client',
  //   component: cguvClient
  // },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

export default router
